import { Mail } from 'lucide-react';

import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import { parseHtml } from '@/lib/html/parse';

export default function AnalysisSummary() {
  const {
    analysis: { analysis },
  } = useEmail();

  const hasSummary =
    Boolean(analysis?.subject) && analysis?.summary_bullets !== undefined;

  if (!hasSummary) return null;

  return (
    <div
      className="flex w-full flex-col gap-1 rounded-lg border p-2"
      data-onboarding-id="ai-summary"
    >
      <p className="text-foreground text-xs font-bold">{analysis.subject}</p>

      {analysis.summary_bullets.map((item, index) => (
        <div className="flex gap-2" key={index}>
          <Mail className="text-primary-500 mt-1 h-3 w-3 shrink-0" />

          <div className="text-foreground/85 text-xs">{parseHtml(item)}</div>
        </div>
      ))}
    </div>
  );
}
